import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const AcIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    clipPath: "url(#clip0_5369_63237)"
  }, __jsx("path", {
    d: "M16.5 8.75H13.3725L15.8025 6.32L14.745 5.255L11.25 8.75H9.75V7.25L13.245 3.755L12.18 2.6975L9.75 5.1275V2H8.25V5.1275L5.82 2.6975L4.755 3.755L8.25 7.25V8.75H6.75L3.255 5.255L2.1975 6.32L4.6275 8.75H1.5V10.25H4.6275L2.1975 12.68L3.255 13.745L6.75 10.25H8.25V11.75L4.755 15.245L5.82 16.3025L8.25 13.8725V17H9.75V13.8725L12.18 16.3025L13.245 15.245L9.75 11.75V10.25H11.25L14.745 13.745L15.8025 12.68L13.3725 10.25H16.5V8.75Z",
    fill: color
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_5369_63237"
  }, __jsx("rect", {
    width: size,
    height: size,
    fill: "white",
    transform: "translate(0 0.5)"
  }))));
};
export default AcIcon;